export default __webpack_public_path__ + "static/media/Choose1.a8a7a507.png";